import { render } from "./SelectOptions.vue?vue&type=template&id=1c15327d&scoped=true"
import script from "./SelectOptions.vue?vue&type=script&lang=js"
export * from "./SelectOptions.vue?vue&type=script&lang=js"

import "./SelectOptions.vue?vue&type=style&index=0&id=1c15327d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c15327d"]])

export default __exports__